module.exports = __webpack_public_path__ + "assets/img/1.3526d1f3.jpg";